import { Card } from 'shared/ui/card';
import { TextInfo } from 'shared/ui/text-info';

const PatientInfoCard = () => (
  <Card className="w-full">
    <div className="w-full flex justify-between">
      <p className="text-lg font-bold">Informasi Pasien</p>
    </div>
    <div className="w-full grid grid-cols-3 gap-4 ">
      <TextInfo title="Nama Pasien" desc="Rizky Pratama" />
      <TextInfo title="No. KTP" desc="1234567890123456" />
      <TextInfo title="Tanggal Lahir" desc="15 April 1985" />
      <TextInfo title="Penyedia Asuransi" desc="Asuransi Sejahtera" />
      <TextInfo
        title="Status"
        desc={
          <span className="flex items-center px-3 py-0.5 rounded-2xl bg-green-100 text-sm text-green-700">
            Aktif
          </span>
        }
      />
      <TextInfo
        title="Tanggal Cakupan"
        desc="01 Januari 2025 - 31 Desember 2025"
      />
    </div>
  </Card>
);

export default PatientInfoCard;
